// extracted by mini-css-extract-plugin
export default {"parent":"loading_parent__VL9RI","lds_spinner":"loading_lds_spinner__lnESd"};